import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { withPathParams } from '@helpcenter/with-path-params';
import { fetchForgotPasswordModel } from 'epics/model/forgot-password';
import { fetchLoginModel } from 'epics/model/login';
import type { State } from 'state';
import { checkLoginActionSuccess, exitTestModeAction, resetLogin } from 'state/actions/login';
import { successfullyLoggedIn } from 'state/actions/user';

import { getIsAnonymousEnabled } from 'state/selectors/env';
import { getResetUrl } from 'state/selectors/forgot-password';
import { getSharedPortalName } from 'state/selectors/help-center';
import { getLogin, getIsLoginLoaded, getLoginUIState } from 'state/selectors/login';
import { isLoggedIn } from 'state/selectors/user';
import withAnalyticsContext from '@atlaskit/analytics-next/withAnalyticsContext';
import withAnalyticsEvents from '@atlaskit/analytics-next/withAnalyticsEvents';
import LoginStateful from './login';

const selector = createSelector(
	(state: State) => getSharedPortalName(state),
	(state: State) => getLogin(state),
	(state: State) => getIsLoginLoaded(state),
	(state: State) => getResetUrl(state),
	(state: State) => isLoggedIn(state),
	(state: State) => getLoginUIState(state),
	(state: State) => getIsAnonymousEnabled(state),
	(
		helpCenterName,
		loginModel,
		loaded,
		resetUrl,
		isUserLoggedIn,
		loginUIState,
		isAnonymousEnabled,
	) => ({
		helpCenterName,
		loginModel,
		resetUrl,
		loginUIState,
		isAnonymousEnabled,
		isLoggedIn: isUserLoggedIn,
		isLoading: !loaded,
	}),
);

export default connect(selector, {
	resetLogin,
	fetchLoginModel,
	checkLoginActionSuccess,
	fetchForgotPasswordModel,
	successfullyLoggedInAction: successfullyLoggedIn,
	onExitTestMode: exitTestModeAction,
})(
	withAnalyticsContext({ component: 'login' })(
		withAnalyticsEvents()(withPathParams(LoginStateful)),
	),
);
